const REGEX_FRACTIONAL_QUOTE_OPT_1_DIGIT = /^-?[0-9]*(?:\'?[0-9]{0,1})$/;
const REGEX_FRACTIONAL_QUOTE_OPT_2_DIGITS = /^-?[0-9]*(?:\'?[0-9]{0,2})$/;
const REGEX_FRACTIONAL_QUOTE_OPT_3_DIGITS = /^-?[0-9]*(?:\'[0-9]{0,3})?$/;

const REGEX_FRACTIONAL_OPTIONS_QUOTE_OPT_1_DIGIT = /^[0-9]*(?:\'?[0-9]{0,1})$/;
const REGEX_FRACTIONAL_OPTIONS_QUOTE_OPT_2_DIGITS = /^[0-9]*(?:\'?[0-9]{0,2})$/;
const REGEX_FRACTIONAL_OPTIONS_QUOTE_OPT_3_DIGITS = /^[0-9]*(?:\'[0-9]{0,3})?$/;

export function PriceRegexValidator(
  PriceValue,
  PriceType,
  decimalPlaces,
  componentUsedIn,
) {
  if (
    PriceValue === null ||
    PriceValue === undefined ||
    PriceValue === 0 ||
    PriceValue === ""
  ) {
    return true;
  }
  console.log("JJ ", componentUsedIn);
  switch (PriceType) {
    case "NotFractional":
      let regexString_NotFractional;
      if (componentUsedIn === "optionsGrid") {
        if (decimalPlaces === 0) {
          regexString_NotFractional = `^[0-9]*$`;
        } else {
          regexString_NotFractional = `^[0-9]*(?:\\.[0-9]{0,${decimalPlaces}})?$`;
        }
      } else {
        if (decimalPlaces === 0) {
          regexString_NotFractional = `^-?[0-9]*$`;
        } else {
          regexString_NotFractional = `^-?[0-9]*(?:\\.[0-9]{0,${decimalPlaces}})?$`;
        }
      }
      const regex_NotFractional = new RegExp(regexString_NotFractional);
      return regex_NotFractional.test(PriceValue);
    case "Eighths":
    case "Halves": // Only Options not Futures
      if (componentUsedIn === "optionsGrid") {
        return REGEX_FRACTIONAL_OPTIONS_QUOTE_OPT_1_DIGIT.test(PriceValue);
      } else {
        return REGEX_FRACTIONAL_QUOTE_OPT_1_DIGIT.test(PriceValue);
      }
    case "ThirtySeconds":
    case "SixtyFourths": // Only Options not Futures
      if (componentUsedIn === "optionsGrid") {
        return REGEX_FRACTIONAL_OPTIONS_QUOTE_OPT_2_DIGITS.test(PriceValue);
      } else {
        return REGEX_FRACTIONAL_QUOTE_OPT_2_DIGITS.test(PriceValue);
      }
    case "HalfThirtySeconds":
    case "QuarterThirtySeconds":
    case "EighthThirtySeconds":
    case "HalfSixtyFourths": // Only Options not Futures
      if (componentUsedIn === "optionsGrid") {
        return REGEX_FRACTIONAL_OPTIONS_QUOTE_OPT_3_DIGITS.test(PriceValue);
      } else {
        return REGEX_FRACTIONAL_QUOTE_OPT_3_DIGITS.test(PriceValue);
      }
    case "Quarters": //products not available
    case "Sixteenths": //products not available
      return true; // Or handle as an error/false if validation is strictly needed
    default:
      return false; // error for unknown PriceType
  }
}
